/* eslint-disable complexity */
import React from 'react';
import headingSchema from '../../../lib/composer/schemas/heading';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import textSchema from '../../../lib/composer/schemas/text';
import { ctaSchema, ctasSchema } from '../../../lib/composer/schemas/cta';
import themeSchema from '../../../lib/composer/schemas/theme';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import Subheading from '../block-ui/Subheading';
import Heading from '../block-ui/Heading';
import CTAs from '../block-ui/CTAs';
import RichText from '../block-ui/RichText';
import { ComposerBlockElement, TextBannerProps } from '../../../types/composer';

/**
 * Header block for sharing.
 */
export const Headers: React.FC<TextBannerProps> = ({
  heading,
  theme,
  subheading,
  topHeader,
}): JSX.Element => {
  return (
    <>
      {!!heading && (
        <Heading
          text={heading}
          theme={theme}
          topHeader={topHeader}
          textProps="text-center"
        />
      )}
      {!!subheading && (
        <Subheading
          topHeader={topHeader}
          text={subheading}
          theme={theme}
          textProps="text-center"
        />
      )}
    </>
  );
};

/**
 * Text banner block.
 */
const TextBanner: ComposerBlockElement = (props: TextBannerProps) => {
  const {
    heading,
    subheading,
    text,
    cta: ctaProps,
    ctas: ctasProps,
    theme = '',
    topHeader,
  } = props;
  const headerProps = { heading, theme, subheading, topHeader };
  const colors = useColors();

  const bg = colors[theme] || 'bg-0';
  const ctas = [...(ctaProps?.caption ? [ctaProps] : []), ...(ctasProps || [])];

  return (
    <Box bg={bg}>
      <Box p={3} maxWidth={1000} m="auto">
        <Flex
          flex={1}
          alignItems="center"
          flexDirection="column"
          sx={{ gap: 3 }}
        >
          <Headers {...headerProps} />
          {!!text && <RichText html={text} theme={theme} alignment="center" />}

          <CTAs ctas={ctas} theme={theme} />
        </Flex>
      </Box>
    </Box>
  );
};

TextBanner.schema = {
  name: 'text-banner',
  label: 'Text Banner',
  editableProps: [
    headingSchema,
    subheadingSchema,
    textSchema,
    ctaSchema,
    ctasSchema,
    themeSchema,
  ],
};

export default TextBanner;
